import { useConfig } from './react/context/ConfigurationContext'
import useCategorizedTreatments from './react/hooks/useCategorizedTreatments'
import useClinic from './react/hooks/useClinic'

/**
 * We will preload clinic information in order
 * to avoid loading during the booking process
 */
export const InitialDataPrefetch = () => {
  const { clinicId } = useConfig()
  useClinic(clinicId)
  useCategorizedTreatments()
  return null
}
